// @flow
import * as React from 'react';
import { VersionContext } from 'routes/RouteProvider';

type InjectedProps = {|
  +version: string,
|};

function withVersion<OwnProps>(
  WrappedComponent: React.AbstractComponent<{|
    ...OwnProps,
    ...InjectedProps,
  |}>
): React.AbstractComponent<OwnProps> {
  function WithVersion(props) {
    return (
      <VersionContext.Consumer>
        {(version) => <WrappedComponent version={version} {...props} />}
      </VersionContext.Consumer>
    );
  }
  return WithVersion;
}

export default withVersion;
